import { GetSecretaryByCpf } from 'domain/usecases/secretary/get-secretary-by-cpf'
import { SecretaryRepository } from 'repository/interfaces/secretary-repository'

export class RemoteGetSecretaryByCpf implements GetSecretaryByCpf {
  private readonly secretaryRepository: SecretaryRepository

  constructor(secretaryRepository: SecretaryRepository) {
    this.secretaryRepository = secretaryRepository
  }

  execute(params: GetSecretaryByCpf.Params): Promise<GetSecretaryByCpf.Model> {
    return this.secretaryRepository.getSecretaryByCpf(params)
  }
}
